var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#ADA7C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1786 12.5741C22.0864 11.8086 23.4136 11.8086 24.3214 12.5741L31.6339 18.7405C32.183 19.2037 32.5 19.8855 32.5 20.6039V31.2236C32.5 32.2706 31.6512 33.1194 30.6042 33.1194H26.8125C25.7655 33.1194 24.9167 32.2706 24.9167 31.2236V25.2652C24.9167 25.1157 24.7954 24.9944 24.6458 24.9944H20.8542C20.7046 24.9944 20.5833 25.1157 20.5833 25.2652V31.2236C20.5833 32.2706 19.7345 33.1194 18.6875 33.1194H14.8958C13.8488 33.1194 13 32.2706 13 31.2236V20.6039C13 19.8855 13.3169 19.2037 13.8661 18.7405L21.1786 12.5741ZM23.2738 13.8164C22.9712 13.5612 22.5288 13.5612 22.2262 13.8164L14.9137 19.9828C14.7306 20.1372 14.625 20.3645 14.625 20.6039V31.2236C14.625 31.3732 14.7463 31.4944 14.8958 31.4944H18.6875C18.8371 31.4944 18.9583 31.3732 18.9583 31.2236V25.2652C18.9583 24.2182 19.8071 23.3694 20.8542 23.3694H24.6458C25.6929 23.3694 26.5417 24.2182 26.5417 25.2652V31.2236C26.5417 31.3732 26.6629 31.4944 26.8125 31.4944H30.6042C30.7538 31.4944 30.875 31.3732 30.875 31.2236V20.6039C30.875 20.3645 30.7694 20.1372 30.5863 19.9828L23.2738 13.8164Z",
    fill: "#1F1D28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.9a88458ab3813b441e05a7333d8516d1.svg";
export { ForwardRef as ReactComponent };